import React, { useState } from 'react';
import Axios from 'axios';
import * as Routes from '@/modules/routes';
import SPAButton from '@/components/admin/SysadminSPA/shared/SPAButton';
import SPAInput from '@/components/admin/SysadminSPA/shared/SPAInput';
import SPAPageHeader from '@/components/admin/SysadminSPA/shared/SPAPageHeader';
import CompletionList from './CompletionList';
import type { CompletionRecord } from './types';

const labelClass = 'tw-mb-1 tw-block tw-text-xs tw-text-spa-secondary';

// AIDEV-NOTE: Mounted only inside the sysadmin SPA (/langfuse/traces) and owns its page header.
const Index = () => {
  const [completions, setCompletions] = useState<CompletionRecord[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [modelId, setModelId] = useState('');
  const [modelType, setModelType] = useState('');
  const canSubmit = Boolean(modelType.trim() && modelId.trim());

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit) return;

    setIsLoading(true);
    setError(null);
    setCompletions(null);

    Axios.get<CompletionRecord[]>(Routes.for_model_admin_langfuse_traces_path(), {
      params: { model_id: modelId, model_type: modelType },
    })
      .then(res => setCompletions(res.data))
      .catch(() => setError('Failed to load completions.'))
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      <SPAPageHeader title="Trace Viewer" />
      <p className="tw-mb-5 tw-mt-0 tw-text-sm tw-text-spa-secondary">
        Look up LLM completions and their Langfuse traces for any model record.
      </p>

      <form className="tw-mb-5 tw-flex tw-flex-wrap tw-items-end tw-gap-x-4 tw-gap-y-3" onSubmit={handleSubmit}>
        <div className="tw-w-56">
          <label className={labelClass} htmlFor="model-type">Model type</label>
          <SPAInput
            id="model-type"
            placeholder="e.g. AIValidationReport"
            value={modelType}
            onChange={e => setModelType(e.target.value)}
          />
        </div>
        <div className="tw-w-36">
          <label className={labelClass} htmlFor="model-id">Model ID</label>
          <SPAInput
            id="model-id"
            placeholder="e.g. 12345"
            value={modelId}
            onChange={e => setModelId(e.target.value)}
          />
        </div>
        <SPAButton disabled={isLoading || !canSubmit} type="submit" variant="primary">
          {isLoading ? 'Looking up…' : 'Look up'}
        </SPAButton>
      </form>

      {error && <p className="tw-m-0 tw-text-sm tw-text-spa-error">{error}</p>}

      {completions && <CompletionList completions={completions} />}
    </>
  );
};

export default Index;
